































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace, Getter } from 'vuex-class';
import quoteList from '@/components/quote-list.vue';
import { ActionConstants } from '@/stores/quotes/action-constants';
import Quote from '@/pages/quote.vue';
import { Customer } from '@/models/customer';
import { Site } from '@/models/site';

const quoteModule = namespace('quote');
const userModule = namespace('user');

@Component({
    components: {
        quoteList,
    },
})
export default class Quotes extends Vue {
    public isLoading: boolean = true;
    @quoteModule.Getter('allQuotesTotalPages') public totalPages: number;
    @quoteModule.Getter('allQuotesPageSize') public currentPageSize: number;
    @quoteModule.Getter('allQuotesTotal') public totalQuotes: number;
    @quoteModule.Getter('allQuotes') public quotes: Array<Quote>;
    @quoteModule.Getter('allQuotesPage') public currentPage: number;
    @quoteModule.Getter('allQuotesFilterStatus') public filterStatus: Array<Quote>;
    @quoteModule.Getter('allQuotesFrom') public from: string | null;
    @quoteModule.Getter('allQuotesTo') public to: string | null;
    @userModule.Getter('currentCustomer') public currentCustomer: Customer | null;
    @userModule.Getter('currentSite') public currentSite: Site | null;

    @Watch('currentCustomer')
    public async onCustomerChanged(value: Customer): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
    }
    @Watch('currentSite')
    public async onSiteChanged(value: Site): Promise<void> {
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
    }
    public async handlePageChanged(value: number): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllQuotesPage, value);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: null, to: null });

        this.isLoading = false;
    }
    public async handleStatusChanged(value: number | string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllQuotesFilterStatus, value);
        await this.$store.dispatch(ActionConstants.updateAllQuotesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleFromChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllQuotesFrom, value);
        await this.$store.dispatch(ActionConstants.updateAllQuotesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async handleToChanged(value: string | null): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(ActionConstants.updateAllQuotesTo, value);
        await this.$store.dispatch(ActionConstants.updateAllQuotesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });

        this.isLoading = false;
    }
    public async mounted(): Promise<void> {
        this.isLoading = true;
        await this.$store.dispatch(ActionConstants.updateAllQuotesPage, 1);
        await this.$store.dispatch(ActionConstants.fetch, { status: this.filterStatus, page: this.currentPage, pageSize: this.currentPageSize, from: this.from, to: this.to });
        this.isLoading = false;
    }
}
